import { ElasticSearchResponse, Front, FrontDocument } from '@shared/services/elastic-search/models';

export const frontsSerializer = (fronts: ElasticSearchResponse<FrontDocument>): Front[] =>
  fronts.hits.hits.map((front) => {
    const f = front._source;
    return {
      hasHandle: f.field_handle?.[0] ?? true,
      images: f.field_images ?? [],
      title: f.title?.[0] ?? '',
    };
  });
